export default `
h1 {
  font-size: 2.25rem;
}

h2 {
  font-size: 1.85rem;
}

h3 {
  font-size: 1.55rem;
}

h4 {
  font-size: 1.25rem;
}

h5 {
  font-size: 1rem;
}

ol {
  list-style-type: decimal;
  padding-inline-start: 2rem;
}

ul {
  padding-inline-start: 2rem;
  list-style-type: disc;
}
`;
